var $jq = jQuery.noConflict();

$jq(document).ready(function(){
   

   $jq('.addtocart_txt').css('opacity', '1' );
  
});
  
  $jq(document).ready(function(){
    $jq('.add_to_cart_ajax').click(function(e){ 
      if($jq(this).hasClass("disabled")) return;
      $btnclass=$jq(this);
      $jq(this).children('.adding_txt').delay(200).animate({ opacity: 1 }, 700);
      $jq(this).children('.addtocart_txt').delay(400).animate({ opacity: 0 }, 900);   
  
        if($jq('.dummy_ATC_button_main .dummy_ATC_button').length){
          $jq('.dummy_ATC_button_main .dummy_ATC_button .atc_text').css('opacity', 0);
          $jq('.dummy_ATC_button_main .dummy_ATC_button .adding_txt').delay(300).animate({ opacity: 1 }, 700);
          $jq('.dummy_ATC_button_main .dummy_ATC_button .added_txt').delay(500).animate({ opacity: 1 }, 900);
        }
  
       $jq(this).addClass('pink_bg');
      var pid = $jq(this).attr('data-pid');
      var qty = 1;
      if($jq(this).parents('.grid-action').find('.qty_box')){
        qty = $jq(this).parents('.grid-action').find('.qty_box input').val();
      }
        // jQuery.post('/cart/add.js', { 
        //   quantity: 1, 
        //   id: pid 
        // });

      $jq.ajax({
        url: '/cart/add.js',
        data: { 
          quantity: qty, 
          id: pid 
        },
        dataType: "json",
        cache: false,
        success: function(added_item) {
          const monster_active = !!document.querySelector('script[src*="/cart_renderer"]');
          if (monster_active) {
            let attempts = 0;

            function checkAndRun() {
              attempts++;

              if (typeof window.openCart === 'function' && typeof window.monster_refresh === 'function') {
                openCart();
                monster_refresh(false);
                clearInterval(interval);
                 $btnclass.removeClass('pink_bg');
                
                $btnclass.children('.adding_txt').animate({ opacity: 0 }, 700);
               $btnclass.children('.added_txt').animate({ opacity: 1 }, 900);   
                
                if($jq('.dummy_ATC_button_main .dummy_ATC_button').length){
                  $jq('.dummy_ATC_button_main .dummy_ATC_button .added_txt').delay(200).animate({ opacity: 0 }, 500);
                  $jq('.dummy_ATC_button_main .dummy_ATC_button .adding_txt').delay(400).animate({ opacity: 0 }, 700);
                  $jq('.dummy_ATC_button_main .dummy_ATC_button .atc_text').css('opacity', 1);
                }
                return;
              } else if (attempts >= 20) {
                clearInterval(interval);
              }
            }

            checkAndRun();

            const interval = setInterval(checkAndRun, 1000);
          }
          $jq.ajax({
              url: '/cart.js',
              dataType: "json",
              cache: false,
              success: function(cart) {
              refreshCart(cart, added_item);
              top_shipping_earning(cart);
              window.setTimeout(function() {                 
                $jq('#min-cart #min-cart_a').trigger('click');
                 $btnclass.removeClass('pink_bg');
                
                $btnclass.children('.adding_txt').animate({ opacity: 0 }, 700);
               $btnclass.children('.added_txt').animate({ opacity: 1 }, 900);   
                
                if($jq('.dummy_ATC_button_main .dummy_ATC_button').length){
                  $jq('.dummy_ATC_button_main .dummy_ATC_button .added_txt').delay(200).animate({ opacity: 0 }, 500);
                  $jq('.dummy_ATC_button_main .dummy_ATC_button .adding_txt').delay(400).animate({ opacity: 0 }, 700);
                  $jq('.dummy_ATC_button_main .dummy_ATC_button .atc_text').css('opacity', 1);
                }
                
              }, 100);
            }
          });
          backtocart($btnclass);
        }
      });
      
      setTimeout(function(){ 
   	 
            $jq.ajax({
                  url: '/cart.js',
                  dataType: "json",
                  cache: false,
                  success: function(cart) {
                  refreshCart(cart);
                  top_shipping_earning(cart);
                  window.setTimeout(function() {                 
                    $jq('#min-cart #min-cart_a').trigger('click');
                     $btnclass.removeClass('pink_bg');
                    
                    $btnclass.children('.adding_txt').animate({ opacity: 0 }, 700);
      			   $btnclass.children('.added_txt').animate({ opacity: 1 }, 900);   
                    
                    if($jq('.dummy_ATC_button_main .dummy_ATC_button').length){
                      $jq('.dummy_ATC_button_main .dummy_ATC_button .added_txt').delay(200).animate({ opacity: 0 }, 500);
                      $jq('.dummy_ATC_button_main .dummy_ATC_button .adding_txt').delay(400).animate({ opacity: 0 }, 700);
                      $jq('.dummy_ATC_button_main .dummy_ATC_button .atc_text').css('opacity', 1);
                    }
                    
                  }, 100);
                }
            });
       backtocart($btnclass);
      },1400); 
          
  	    e.preventDefault();
      });
    
    
   
    
    $jq('form.product-form button[type="submit"]').click(function (e) {
      var line_prop_main_product_ID;
      if($jq('.product-template__container .upsell_product_JS').length){
        var $this = $jq('.product-template__container .upsell_product_JS'),
            upsell_product_id = parseInt($jq($this).attr('upsell_product_id')),
            main_product_ID = parseInt($jq($this).attr('main_product_ID'));
        
        var line_prop_main_product_ID = '&properties[_Main product ID]=' + main_product_ID;
        
         let add_upsell_product = {
           "items": [
             {
               "id": upsell_product_id,
               "quantity": 1,
               "properties": {
                    "_Main product ID": main_product_ID
                }
             }
           ]
         }
        
         $jq.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: add_upsell_product,
          async: false,
          dataType: 'json',
          success: function(success) {
            // console.log('Added main and upsell products');
          }
         });
      }
      
    //$jq(this).children('span.addtocart_txt_change').html('Adding');
  
    $jq(this).children().find('.adding_txt').delay(200).animate({ opacity: 1 }, 700);
    $jq(this).children().find('.addtocart_txt').delay(100).animate({ opacity: 0 }, 500);
    hide_price_button_mobile();
  
    $jq(this).addClass('pink_bg');
  
    var upsell_pro = [];
    if ($jq('.upsell_list').length) {
      $jq('.upsell_list').each(function () {
        if ($jq(this).find('input').is(':checked')) {
          upsell_pro.push({ 'id': $jq(this).find('input').val(), 'quantity': 1 });
        }
      })
  
      if (upsell_pro.length) {
        $jq.ajax({
          type: "POST",
          url: '/cart/add.js',
          data: {
            'items': upsell_pro
          },
          async: false,
          success: function () {
            ``
  
          }
        });
      }
    }
    
    $jq.ajax({
      type: "POST",
      url: '/cart/add.js',
      data: $jq('form[action="/cart/add"]').serialize() + (line_prop_main_product_ID ? line_prop_main_product_ID : ''),
      async: false,
      success: function () {
        ``
      }
    });
  

      setTimeout(function () {
    
        $jq.ajax({
          url: '/cart.js',
          dataType: "json",
          cache: false,
          success: function (cart) {
            refreshCart(cart);
            top_shipping_earning(cart);
            window.setTimeout(function () {
              $jq('#min-cart #min-cart_a').trigger('click');
              $jq('form.product-form button').removeClass('pink_bg');
              $jq('form.product-form button .adding_txt').animate({ opacity: 0 }, 700);
              $jq('form.product-form button .added_txt').animate({ opacity: 1 }, 900);
            }, 100);
          }
        });
    
      }, 1400);
  
    setTimeout(function () {
  
      $jq('.addtocart_txt').animate({ opacity: 1 }, 700);
      $jq('.added_txt').animate({ opacity: 0 }, 900);
      show_price_button_mobile();
    }, 5500);
    e.preventDefault();
  });
    
  
});

function hide_price_button_mobile()
{
  var window_w = $jq(window).width();
  if(window_w<769){
   // $jq('.mobile-view-price').css("display", "none");
   // $jq('.product-form__item.product-form__item--submit button span').css("left", "auto");
  }
}
function show_price_button_mobile()
{
 var window_w = $jq(window).width();
  if(window_w<769){
   // $jq('.mobile-view-price').removeAttr("style");
   // $jq('.product-form__item.product-form__item--submit button span').removeAttr("style");
   }
}
 function backtocart($btnclass)
    {
     
      
         setTimeout(function(){ 
                 $btnclass.children('.addtocart_txt').animate({ opacity: 1 }, 700);
                  $btnclass.children('.added_txt').animate({ opacity: 0 }, 900); 
         },5000);
    }

function top_shipping_earning(cart)
{
  	  						
		
    var free_price = "";
    
    var total_price =  Shopify.formatMoney(cart.total_price) ; 
    total_price= total_price.replace("$", "");
 
     if(total_price < free_price)
   { 
     
     var  earning_amount =  (parseFloat(free_price) -  parseFloat(total_price))*100;   
     
     if($jq('p.announcement-bar__message span').hasClass('shipping_header_msg')){
  	 	$jq('p.announcement-bar__message .shipping_header_msg').html('  '+ Shopify.formatMoney(earning_amount) +'  ');
        }
         else if($jq('p.announcement-bar__message span').hasClass('show_jquery_price'))
        {
          $jq('p.announcement-bar__message .show_jquery_price').html('  '+ Shopify.formatMoney(earning_amount) +'  ');
        }
      var window_w = $jq(window).width();
        if(window_w<769)
        {
          $jq('.announcement-bar__message .announcement-bar_right').hide();
          $jq('.announcement-bar__message .shipping_header_msg').show();
        }
                                                               
   }else
    { 
       if($jq('p.announcement-bar__message span').hasClass('shipping_header_msg')){
  	 	 $jq('p.announcement-bar__message .shipping_header_msg').html('');     
        } else if($jq('p.announcement-bar__message span').hasClass('show_jquery_price'))
        {
           $jq('p.announcement-bar__message .show_jquery_price').html('');     
        }                                                              
                                                                    
                                                         
     }
}

function refreshCart(cart, recent_item = null) {
    $cartBtn = $jq(".cart_popup");
    if ($cartBtn) {
        var $cartCount = $cartBtn.find('.noof_cart_item');
        var value = $cartCount.text() || '0';
        var cart_items_html = "";
        var $cart = $jq(".cart_product");
        


        if ( cart.item_count == 0) {
           // $cart.append('<li class="mm-label empty_cart"><a href="/cart">empty_cart</a></li>');
           // $cartCount.remove();
        } else {
          if(recent_item) {
            var line_id = 0;
            var variant_title = recent_item.variant_title ?? '';
             cart_items_html =  '<div class="cart_img_txt_box"> <div class="cart_img_box">'+
                          '<img class="cart__image" src="' + recent_item.image.replace(/(\.[^.]*)$/, "_medium$1").replace('http:', '') + '" alt="' + recent_item.title + '" />'+
                          
                       '</div>	 <div class="cart_txt_box">   <div class="title">'+
                              '<a href="' + recent_item.url + '">'+ recent_item.product_title + '</a></div>' +                         
                         
                            '<div class="cart__meta-text">'+                                   
                             ' <div class="mincart-var">' + variant_title +'</div>'+
                             ' <div class="mincart-price"> <span class="money">'+ Shopify.formatMoney(recent_item.final_line_price, $cart.data('money-format')) +'</span> </div>'+
                              
                            '</div></div>   <div class="clearfix"></div>  </div>';
          } else {
            $jq.each(cart.items, function(index, item) {
               
                var line_id = index ;
                 var variantTitle = item.title.split('-');
				 var varientname ='';
              		for(var i=0;i<variantTitle.length;i++)
                    {
                      if(i!=0){
                        varientname += variantTitle[i];
                      }
                    }

                   cart_items_html =  '<div class="cart_img_txt_box"> <div class="cart_img_box">'+
                        		'<img class="cart__image" src="' + item.image.replace(/(\.[^.]*)$/, "_medium$1").replace('http:', '') + '" alt="' + item.title + '" />'+
                                
                       		 '</div>	 <div class="cart_txt_box">   <div class="title">'+
                   					'<a href="' + item.url + '">'+ variantTitle[0] + '</a></div>' +                         
                               
                                  '<div class="cart__meta-text">'+                                   
                                   ' <div class="mincart-var">' + varientname +'</div>'+
                                   ' <div class="mincart-price"> <span class="money">'+ Shopify.formatMoney(item.price, $cart.data('money-format')) +'</span> </div>'+
                                    
                                  '</div></div>   <div class="clearfix"></div>  </div>';
              	
                return false;         
            });
          }
          
                cart_items_html += ' <hr class="border-mincart"/>'+
                        '<div class="mincart_footer"> '+  
                           ' <div class="cart_item_subtotal_box">'+
                               ' <div class="item_bag">';
          if(cart.item_count == 1){
               cart_items_html += 'Item';
          	}
            else {  
           		cart_items_html += 'Items';
            }
            cart_items_html += ' in bag: '+ cart.item_count +
            '</div>'+
                                '<div class="Subtotal">Subtotal: <span class="money"> ' + Shopify.formatMoney(cart.total_price, $cart.data('money-format')) + '</span> </div>'+
                           	'<div class="clearfix"></div>'+
                          '</div>'+
                          
                          '<div class="mincart_btn_box"> <a href="/cart">View Bag</a> <a href="/checkout" class="checkout_btn">checkout</a></div>'+
                          '</div>';
            

			$cart.html('');
            $cart.append(cart_items_html);
            $jq('.mincart_related_item_box').show();
            $jq('.cart_img_full').css('display', 'inline-block');
            $jq('.cart_img_empty').hide();
      
           /* $jq('html, body').animate({
               scrollTop: 0
             }, 1000); */
           
          

            
          		 var newCurrency = $jq(".currency-picker").val();
                  Currency.convertAll(Currency.currentCurrency, newCurrency);
                  $jq('.selected-currency').text(Currency.currentCurrency); 
          		// convertCurrencies();   
             
        } 
    }
}

// function upsell_product_update() {
//   $jq.ajax({
//     url: '/cart.js',
//     dataType: "json",
//     success: function(cart){
//       console.log("cart: ",cart)
//     }
//   });
// }

// upsell_product_update();

